module.exports = __webpack_public_path__ + "static/media/VideoJigsaw.dbcfce02.png";